import React from "react";
import SimpleTooltip from "./SimpleTooltip";
import { FaTimes } from "react-icons/fa";

class TagItem extends React.Component {
  constructor(props) {
    super(props);

    const { readOnly = false } = this.props;

    this.state = {
      readOnly,
    };

    this.handleClicked = this.handleClicked.bind(this);
    this.handleDeleted = this.handleDeleted.bind(this);
  }

  handleClicked() {
    if (!this.state.readOnly && this.props.onClick) {
      this.props.onClick();
    }
  }

  handleDeleted() {
    if (!this.state.readOnly && this.props.onDelete) {
      this.props.onDelete();
    }
  }

  render() {
    const {
      children,
      tag,
      textColor = "text-gray-800",
      tooltip,
      isTextOnly = false,
      selected = false,
    } = this.props;

    const { readOnly } = this.state;

    const customClassName = () => {
      let result = isTextOnly ? "" : "border border-gray-400";
      if (readOnly) return result + " pointer-events-none";
      result += ` cursor-pointer ${
        selected
          ? "bg-blue-600 text-white"
          : `${textColor} bg-gray-100 hover:bg-gray-200`
      }`;
      return result;
    };

    return (
      <SimpleTooltip tooltipText={tooltip} place="top">
        <div
          className={`rounded flex items-center justify-center gap-1 px-2 py-1 text-xs ${customClassName()}`}
          style={
            readOnly ? { backgroundColor: "#E5E5E5", color: "#383838" } : {}
          }
          onClick={() => this.handleClicked()}
        >
          {children || tag}

          {!readOnly && (
            <span
              className="cursor-pointer text-xs text-gray-500 hover:text-gray-600"
              onClick={(e) => {
                e.stopPropagation();
                this.handleDeleted();
              }}
            >
              <FaTimes />
            </span>
          )}
        </div>
      </SimpleTooltip>
    );
  }
}

export default TagItem;
